<template>
  <div>
    <b-row class="mb-2">
      <b-col class="col-auto">
        <a href="https://www.pexels.com/" target="pexels">
          <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32">
            <path d="M2 0h28a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z" fill="#05A081"></path>
            <path d="M13 21h3.863v-3.752h1.167a3.124 3.124 0 1 0 0-6.248H13v10zm5.863 2H11V9h7.03a5.124 5.124 0 0 1 .833 10.18V23z" fill="#fff"></path>
          </svg>
          <small class="text-muted mr-2" v-if="!imageNameOnly">{{ trans('photos_provided_by_pexels') }}</small>
        </a>
      </b-col>
      <b-col>
        <p class="mb-0 pl-1 text-center">
          <b-form-input v-model="query" placeholder="sport" type="search" size="sm" @search="onSearch" @keydown.enter="onSearch" style="max-width: 240px; display: inline-block;" />
          <small class="text-muted">
            {{ totalRows }}
            {{ trans('image' + (totalRows > 1 ? 's' : '')).toLowerCase() }}
          </small>
        </p>
      </b-col>
      <b-col class="col-auto text-right">
        <b-button size="sm" variant="link" class="pb-0" @click="onRefresh" :title="trans('refresh')" :disabled="busy">
          <i class="fa fa-fw fa-redo" v-if="!busy"></i>
          <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          id="pexels"
          ref="table"
          class="bg-white table-row-click"
          bordered
          small
          responsive
          show-empty
          :fields="fields"
          :items="provider"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="onRowClick"
        >
          <template v-slot:empty>
            <p align="center">{{ trans('no_image_found') }}</p>
          </template>
          <template v-slot:cell(w170_url)="data">
            <div class="img-wrapper text-center">
              <img :src="data.value" alt="data.item.name" />
            </div>
          </template>
        </b-table>
        <b-pagination
          :per-page="perPage"
          :current-page="currentPage"
          :total-rows="totalRows"
          v-model="currentPage"
          aria-controls="pexels"
          align="center"
        />
      </b-col>
    </b-row>

    <b-modal
      id="show-image-modal"
      :title="item.name"
      size="xl"
      hide-footer
      v-if="!noOpen && !!item"
    >
      <div class="text-center">
        <img :src="item.url" alt="item.name" class="img-fluid" />
      </div>
      <p class="text-center mt-2">
        <strong>{{ trans('source') }}:</strong>
        <a :href="item.source_url" target="pexels">{{ trans('photos_provided_by_pexels') }}</a>
        <strong class="ml-4">{{ trans('author') }}:</strong>
        <a :href="item.photographer_url" target="pexels">{{ item.photographer }}</a>
      </p>
    </b-modal>

  </div>
</template>

<style>
  table#images td>.img-wrapper>img {
    max-height: 170px;
  }
</style>

<script>
  export default {
    props: {
      organization: Object,
      search: String,
      imageNameOnly: Boolean, // image-name-only
      noOpen: Boolean, // no-open
      perPage: {
        type: Number,
        default: 5
      },
    },
    data() {
      let fields = [
        {key: 'w170_url', label: trans('image')},
        {key: 'name', label: trans('name')},
      ]
      if (!this.imageNameOnly) {
        fields.push({key: 'photographer', label: trans('author')})
      }

      return {
        trans: trans,
        moment: moment,
        error: null,
        busy: false,
        fields: fields,
        items: [],
        query: this.search || null,
        currentPage: 1,
        totalRows: 0,
        item: null,
        upload_file: null,
        upload_url: null,
      }
    },
    methods: {
      onSearch() {
        this.currentPage = 1
        this.$refs.table.refresh()
        this.$emit('search', this.query)
      },
      onRefresh() {
        this.$refs.table.refresh()
      },
      onRowClick(item) {
        this.$emit('choose', item)
        if (this.noOpen) return
        this.item = item
        setTimeout(() => {
          this.$bvModal.show('show-image-modal')
        }, 1)
      },
      provider() {
        this.error = null
        this.busy = true
        let url = '/organization/' + this.organization.id + '/media/pexels' +
          '?page=' + this.currentPage + '&per_page=' + this.perPage
        if (this.query) url += '&query=' + encodeURIComponent(this.query)
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.page
          this.totalRows = response.data.total
          this.items = response.data.data
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.handleError(error)
          this.items = []
          return this.items
        })
      },
      handleError(error) {
        this.error = _.errorFromAjax(error)
        this.$bvToast.toast(this.error, {
          title: trans('error'),
          variant: 'danger',
          solid: true,
        })
      }
    },
    mounted() {
      window.pexelsTableComponent = this
    },
  }
</script>